/**
 * 组件上下文：默认组件映射 + @app 应用层覆写
 * 1:1 还原参考项目 @pkg/diffconfig/src/diffComponents.js
 */
import appComponents from '@app/config/components'
import standardComponents from './config/components'
import { validateOverrides } from './validateOverrides'

validateOverrides('components', standardComponents, appComponents)

const components = { ...standardComponents, ...appComponents }
export default components as Record<string, any>
 
